import { render, staticRenderFns } from "./ResetPassModal.vue?vue&type=template&id=4081f3b6"
import script from "./ResetPassModal.vue?vue&type=script&lang=js"
export * from "./ResetPassModal.vue?vue&type=script&lang=js"
import style0 from "./ResetPassModal.vue?vue&type=style&index=0&id=4081f3b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports